import { Fragment, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { ReconstructionModelSetup } from "./ReconstructionModelSetup";
import { ReconstructionModelResult } from "./ReconstructionModelResult";

const ReconstructionModel = () => {
  const id = useParams();
  console.debug(id);
  const { name } = useSelector((state) => state.indicator.moduleData);

  const [result, setResult] = useState({});
  return (
    <Fragment>
      <ReconstructionModelSetup setResult={setResult} />
      <ReconstructionModelResult name={name} result={result} />
    </Fragment>
  );
};
export default ReconstructionModel;
